import Vue from 'vue';
import Component from 'vue-class-component';
import {BOARD_EVENTS} from '@/values/ed-whiteboard.values';
import {Emit} from 'vue-property-decorator';

@Component({})
class EdBlankWhiteboardUsers extends Vue {

    private uniqueUsers: {[socketId: string]: {key: string, name: string, color: string} } = {};


    get users(): {key: string, name: string, color: string} [] {
        // This should obtain a list of connected users from the store
        // That list is maintained continuously
        // Every incoming cursor update message the list is inspected to add a new user if it's not in the list.
        // When a participant leaves (its socket is disconnect), we got notified, so we can delete that entry.
        return Object.keys(this.uniqueUsers).map(socketId => this.uniqueUsers[socketId]);
    }

    /**
     * This handles every cursor update. Here we can determine if a new user should be added to the list.
     */
    public cursorUpdated(cursorMessage: any): void {
        const socketId = cursorMessage.socket;
        if (!this.uniqueUsers[socketId] || this.uniqueUsers[socketId].color !== cursorMessage.color) {
            const newUserMap = this.copyObj(this.uniqueUsers);
            newUserMap[socketId] = {
                key: socketId,
                name  : cursorMessage.user,
                color : cursorMessage.color
            };
            this.uniqueUsers = newUserMap;
        }
    }

    private copyObj(obj: any) {
        const newObj = {};
        for (const prop in obj) {
            newObj[prop] = obj[prop];
        }
        return newObj;
    }

    public otherUserDisconnected(disconnectedUserSocketId: any): void {
        if (this.uniqueUsers[disconnectedUserSocketId]) {
            const newUserMap = this.copyObj(this.uniqueUsers);
            delete newUserMap[disconnectedUserSocketId];
            this.uniqueUsers = newUserMap;
            this.removeUserCursor(disconnectedUserSocketId);
        }
    }

    public removeUserCursor(disconnectedUserSocketId: any): void {
        document.querySelector(`[id^="cursor-${disconnectedUserSocketId}"]`)?.remove();
    }

    public obtainInitials(name: string) : string {
        const nameParts = name.toUpperCase().split(/\s+/);
        return `${nameParts[0]?.charAt(0) ?? ''}${nameParts[1]?.charAt(0) ?? ''}`;
    }

    @Emit()
    public goToUserCursor(user: {key: string}) : string {
        return 'cursor-' + user.key;
    }

    mounted() {
        this.$edEventBus.$on(BOARD_EVENTS.CURSOR_UPDATED, this.cursorUpdated);
        this.$edEventBus.$on(BOARD_EVENTS.USER_DISCONNECTED, this.otherUserDisconnected);
    }

    beforeDestroy() {
        this.uniqueUsers = {};
        this.$edEventBus.$off(BOARD_EVENTS.CURSOR_UPDATED, this.cursorUpdated);
        this.$edEventBus.$off(BOARD_EVENTS.USER_DISCONNECTED, this.otherUserDisconnected);
    }
}

export default Vue.component('ed-blank-whiteboard-users', EdBlankWhiteboardUsers);